package com.milta.core.localization.translations.ro

import com.milta.core.localization.SubscriptionStrings

internal val Subscription = SubscriptionStrings(
    screenTitle = "Abonamentul meu",
    screenSubtitle = "Gestionați abonamentul Milta",
    planDriver = "Șofer",
    planOrganisation = "Companie",
    statusActive = "Activ",
    statusTrial = "Perioadă de probă",
    statusExpired = "Expirat",
    statusCancelled = "Anulat",
    platformLabel = "Platformă",
    productIdLabel = "Produs",
    expiresAtLabel = "Expiră pe",
    noExpiry = "Fără dată de expirare",
    noValue = "—",
    noSubscription = "Niciun abonament activ",
    activateButton = "Activați abonamentul",
    successActivated = "Abonament activat cu succes",
    perMonth = "/lună",
    pitchTitle = "Deblocați toate funcțiile Milta",
    pitchSubtitle = "Alegeți oferta potrivită activității dvs. pentru a continua livrările și gestionarea curselor.",
    featuredBadge = "TOTUL INCLUS",
    driverFeature1 = "Curse & livrări nelimitate",
    driverFeature2 = "Dovadă foto de livrare + semnătură",
    driverFeature3 = "Notificări în timp real",
    orgFeature1 = "Gestionare echipă nelimitată",
    orgFeature2 = "Dashboard web complet",
    orgFeature3 = "Import curse (Excel, PDF, foto)",
    orgFeature4 = "Acces Șofer inclus pentru dvs.",
    purchaseFinePrint = "Plată securizată prin store. Anulabil oricând din setările store-ului.",
    purchasingLabel = "Se procesează…",
    activeCaption = "Abonamentul dvs. Milta",
    nextRenewalLabel = "Următoarea reînnoire",
    includedTitle = "Inclus în oferta dvs.",
    manageOnGooglePlay = "Gestionați pe Google Play",
    manageOnAppStore = "Gestionați pe App Store",
    viewTechnicalDetails = "Vezi detalii tehnice",
    monthNames = listOf("ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"),
    errorNotFound = "Niciun abonament activ găsit",
    errorConflict = "Există deja un abonament activ pentru acest cont",
    errorPlanMismatch = "Planul selectat nu corespunde rolului contului dvs.",
    errorPlanRequired = "Selectați un plan",
    errorPlanInvalid = "Plan selectat invalid",
    errorPlatformRequired = "Platforma este necesară",
    errorPlatformInvalid = "Platformă invalidă. Trebuie să fie AppStore sau GooglePlay",
    errorStoreProductIdRequired = "ID-ul produsului din store este necesar",
    errorReceiptTokenRequired = "Token-ul de chitanță este necesar",
    errorGeneric = "A apărut o eroare. Încercați din nou.",
    trialBannerDaysPrefix = "🎉 Perioadă de probă gratuită: mai aveți ",
    trialBannerDaysBold = "%d zile",
    trialBannerDaysSuffix = " pentru a descoperi Milta fără niciun angajament.",
    trialBannerHoursPrefix = "⏰ Perioada dvs. de probă gratuită se încheie în ",
    trialBannerHoursBold = "%d h",
    trialBannerHoursSuffix = ": abonați-vă pentru a continua să folosiți Milta fără întrerupere.",
)
